import { FEATURE_DECISION_KEYS } from '@web-platform/shared-universal-constants-config';
import { getFeatureDecision } from '@web-platform/shared-universal-utils-frontend/src/config';

import type { TrackingConfig } from '@skyscanner/strevda-tracking';

export const getStrevdaTrackingConfig = (): TrackingConfig => ({
  useNewTrackingEndpoint: getFeatureDecision(FEATURE_DECISION_KEYS.USE_NEW_TRACKING_ENDPOINT),
});
